module.exports = __webpack_public_path__ + "static/img/software1.d8c8ed2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/software1.jpg
// module id = aMhK
// module chunks = 1